"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandsAndCategoriesItems = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const react_1 = require("react");
const MenuItem_1 = require("./MenuItem");
const services_1 = require("../../../services");
const utils_1 = require("../../../utils");
const MenuCategories_1 = require("./MenuCategories");
const MenuBrands_1 = require("./MenuBrands");
const useMenuClickHandlers_1 = require("../useMenuClickHandlers");
const types_1 = require("../../../types");
const hooks_1 = require("../../../hooks");
const Component = ({ businessUnit, catalogSlug, highlightItem, uf, }) => {
    const [brands, setBrands] = (0, react_1.useState)([]);
    const [categories, setCategories] = (0, react_1.useState)([]);
    const isGeneric = (0, utils_1.isGenericReseller)(catalogSlug || utils_1.envConfig.genericUrl || '');
    const genericUser = (0, services_1.getGenericUser)({ uf, businessUnit });
    const { error, facets, resolved, loading, idle } = (0, hooks_1.useFacets)({
        businessUnit,
        catalogSlug: isGeneric ? undefined : catalogSlug,
        uf: isGeneric ? uf || genericUser.addressHomeState : undefined,
    });
    const handleClickItem = (type, item) => {
        const itemName = item.slugName || item.name;
        const typeMap = {
            brand: 'marca',
            category: 'categoria',
        };
        const eventLabel = `menu:${typeMap[type]}:${(0, utils_1.slugfy)(item.slugName || item.name)}`;
        const url = encodeURI(`/${catalogSlug}/${typeMap[type]}?${type}=${itemName}`);
        services_1.GoogleAnalyticsService.event({
            event: 'ga-event',
            'event-category': 'tab-bar',
            'event-action': 'click',
            'event-label': eventLabel,
        });
        (0, useMenuClickHandlers_1.goTo)(url);
    };
    (0, react_1.useEffect)(() => {
        if (resolved) {
            setBrands((0, utils_1.getFacetByField)(facets, types_1.FacetFieldEnum.BRAND));
            setCategories((0, utils_1.getFacetByField)(facets, types_1.FacetFieldEnum.CATEGORY));
        }
    }, [facets, resolved]);
    return error ? null : ((0, jsx_runtime_1.jsxs)(core_1.List, Object.assign({ disablePadding: true }, { children: [(0, jsx_runtime_1.jsx)(MenuItem_1.MenuItem, { name: "Promo\u00E7\u00F5es", slugName: "promocao", businessUnit: businessUnit, Icon: (0, jsx_runtime_1.jsx)(flora_react_icons_1.DiscountIcon, { color: "$nonInteractivePredominant" }), highlight: highlightItem === 'access-promo', onClickItem: (item) => handleClickItem('category', item) }), (0, jsx_runtime_1.jsx)(MenuCategories_1.MenuCategories, { idle: idle, categories: categories, loading: loading || idle, businessUnit: businessUnit, highlightItem: highlightItem, onClickItem: (item) => handleClickItem('category', item) }), (0, jsx_runtime_1.jsx)(MenuBrands_1.MenuBrands, { idle: idle, brands: brands, loading: loading || idle, businessUnit: businessUnit, highlightItem: highlightItem, onClickItem: (item) => handleClickItem('brand', item) })] })));
};
exports.BrandsAndCategoriesItems = (0, react_1.memo)(Component);
